export class Location {
  Name: string;
  Address: string;
  PostalCode: string;
  City: string;
  CountryId: string;
  Phone: string;
}
